"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentList = exports["default"] = exports.SortRequest = exports.PaginationRequest = exports.FilterRequest = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Columns = require("./Columns");

var _ComplexFieldColumns = require("./Columns/ComplexFieldColumns");

var _DateColumn = require("./Columns/DateColumn");

var _AdvancedTableWrapper = _interopRequireWildcard(require("@civicplus/preamble/lib/AdvancedTable/AdvancedTableWrapper"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _Grid = _interopRequireDefault(require("@civicplus/preamble/lib/Grid"));

var _Button = _interopRequireDefault(require("@civicplus/preamble/lib/Button"));

var _Menu = _interopRequireDefault(require("@civicplus/preamble/lib/Menu/Menu"));

var _StringHelper = require("@civicplus/preamble/lib/Utilities/StringHelper");

var _AdvancedTableWrapperConstants = require("@civicplus/preamble/lib/AdvancedTable/AdvancedTableWrapperConstants");

var _CommonTableComponents = require("@civicplus/preamble/lib/Utilities/CommonTableComponents");

var _odataHelper = require("@civicplus/preamble/lib/Utilities/odataHelper");

var _Typography = _interopRequireDefault(require("@civicplus/preamble/lib/Typography"));

var _Config = require("../Utility/Config");

var _Format = require("../Utility/Format");

var _StatusIndicator = _interopRequireDefault(require("@civicplus/preamble/lib/StatusIndicator"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FilterRequest = /*#__PURE__*/function () {
  function FilterRequest(ids = null, lastModifiedDateRange = null, search = null, referenceIds = null, filter = null) {
    (0, _classCallCheck2["default"])(this, FilterRequest);
    this.ids = ids;
    this.lastModifiedDateRange = lastModifiedDateRange;
    this.search = search;
    this.referenceIds = referenceIds;
    this.filter = filter;
  }

  (0, _createClass2["default"])(FilterRequest, [{
    key: "getFilterQuery",
    value: function getFilterQuery() {
      var _this$filter$id$in$va, _this$filter, _this$filter$id, _this$filter$id$in, _this$filter$id$in$va2;

      if (((_this$filter$id$in$va = (_this$filter = this.filter) === null || _this$filter === void 0 ? void 0 : (_this$filter$id = _this$filter.id) === null || _this$filter$id === void 0 ? void 0 : (_this$filter$id$in = _this$filter$id["in"]) === null || _this$filter$id$in === void 0 ? void 0 : (_this$filter$id$in$va2 = _this$filter$id$in.value) === null || _this$filter$id$in$va2 === void 0 ? void 0 : _this$filter$id$in$va2.length) !== null && _this$filter$id$in$va !== void 0 ? _this$filter$id$in$va : 0) > 0) {
        var _this$filter2, _this$filter2$id, _this$filter2$id$in;

        return "id in (".concat((_this$filter2 = this.filter) === null || _this$filter2 === void 0 ? void 0 : (_this$filter2$id = _this$filter2.id) === null || _this$filter2$id === void 0 ? void 0 : (_this$filter2$id$in = _this$filter2$id["in"]) === null || _this$filter2$id$in === void 0 ? void 0 : _this$filter2$id$in.value.join(","), ")");
      }

      return null;
    }
  }]);
  return FilterRequest;
}();

exports.FilterRequest = FilterRequest;

var PaginationRequest = function PaginationRequest(top, skip) {
  (0, _classCallCheck2["default"])(this, PaginationRequest);
  this.top = top;
  this.skip = skip;
};

exports.PaginationRequest = PaginationRequest;

var SortRequest = function SortRequest(column, direction, partition, isSibling, sortProperty) {
  (0, _classCallCheck2["default"])(this, SortRequest);
  this.column = column;
  this.direction = direction;
  this.partition = partition;
  this.isSibling = isSibling;
  this.sortProperty = sortProperty;
};

exports.SortRequest = SortRequest;
var PartitionMap = {
  invariant: "iv"
};
var SortMap = {
  NumberRange: "valueFrom",
  Link: "displayName",
  DateTimeRange: "startDate"
};
var DEFAULT_EMPTY_MESSAGE = "Sorry, we could not find any records.";

function HeaderButtons(props) {
  var addContentButton = props.addContentButton,
      id = props.id;

  if (!addContentButton) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: "prmbl-contentList-buttons",
    id: "".concat(id, "-buttons"),
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    id: "".concat(id, "-buttons-container"),
    container: true,
    justify: "flex-end",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(AddNewButton, props)));
}

function AddNewButton(props) {
  var addContentButton = props.addContentButton,
      id = props.id;
  return addContentButton ? /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "prmbl-contentList-newContent",
    id: "".concat(id, "-new-content-button"),
    color: "primary",
    onClick: addContentButton.onClick
  }, addContentButton.text)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
}

function ActionMenu(props) {
  if (!hasActions(props) || !props.actions) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    id: "content-list-actions-".concat(props.index),
    type: "action",
    items: props.actions.map(function (w) {
      return {
        display: w.display,
        action: function action() {
          w.action([props.row]);
        }
      };
    })
  });
}

function ContentStatusCell(props) {
  var status = props.item.status;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StatusIndicator["default"], {
    status: "CUSTOM",
    shape: "circle",
    color: props.item.statusColor,
    showText: false,
    customText: status
  }));
}

function LastModifiedCell(props) {
  var _props$item$lastModif;

  return /*#__PURE__*/_react["default"].createElement("div", null, (_props$item$lastModif = props.item.lastModified) === null || _props$item$lastModif === void 0 ? void 0 : _props$item$lastModif.toDateString());
}

function PermissionSetCell(item) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !item.permissionSet ? "" : item.permissionSet.name);
}

function CategoriesCell(item) {
  var _item$categories;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (_item$categories = item.categories) === null || _item$categories === void 0 ? void 0 : _item$categories.map(function (x) {
    return x.name;
  }).join(","));
}

function getFieldsToRender(contentType) {
  if (contentType.fields.length < 1) {
    return [];
  }

  var listFields = contentType.fields.filter(function (f) {
    return !f.isHidden && contentType.fieldsInLists.includes(f.name);
  });
  return listFields && listFields.length > 0 ? listFields : [contentType.fields[0]];
}

function getFieldRenderer(field, data, props) {
  var renderer = DefaultFieldRenderers[field.properties.fieldType]; // If we are unable to get the value by the specified partitioning of the content type, just keep falling back until we eventually get the first.

  var value = data[field.partitioning] || data.iv || data.en || data[Object.keys(data)[0]];

  if ((0, _StringHelper.isNullOrWhiteSpace)(value)) {
    return "";
  }

  var valueAsString = value.toString();

  if (!renderer) {
    return valueAsString;
  }

  if (typeof renderer === "function") {
    return renderer(field, value) || valueAsString;
  } // TODO: Fix the FieldPropertiesDto interface or use the correct key here.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore
  // @ts-ignore


  var editor = renderer[field.properties.editor];

  if (!editor) {
    return valueAsString;
  }

  return editor(field, value) || valueAsString;
}

function shouldRenderContent(contentType, fieldName) {
  var field = contentType.fields.find(function (w) {
    return w.name === fieldName;
  });

  if (!field) {
    return false;
  }

  var toRender = getFieldsToRender(contentType);
  return toRender.includes(field);
}

function hasActions(props) {
  return props.actions != null && props.actions.length > 0;
}
/**
 * If the content item does not have some fields filled out, they are missing on the object. This causes the rows to be mis-aligned with the columns
 * when rendering. To fix this, we must add every single property from the content type to the content item data if it is missing it.
 * Once done, we must sort all the properties on the content item data by how they are listed on the content type.
 * @param contentItem
 * @param type
 */


function fixMissingProperties(contentItem, type) {
  var toRender = type.fields;
  var fields = new Set(toRender.map(function (t) {
    return t.name;
  }));
  toRender.forEach(function (t) {
    // Add it to the content item if the content type has the field, but the content item does not.
    if (!contentItem.data[t.name]) {
      contentItem.data[t.name] = {
        iv: null
      };
    }
  });

  for (var _key in Object.keys(contentItem.data)) {
    if (!fields.has(_key)) {
      delete contentItem.data[_key];
    }
  } // Sort the keys of the content item based on how they appear on the content type.


  function sortKeys(obj) {
    var result = {};
    fields.forEach(function (f) {
      result[f] = obj[f];
    });
    return result;
  }

  contentItem.data = sortKeys(contentItem.data);
  return contentItem;
}
/**
 * The default field renderers to decide how a certain field and editor type should display in the table.
 * This can be overriden with the onBuildRow prop.
 */


var DefaultFieldRenderers = {
  DateTimeRange: {
    DateTimeRange: function dateTimeRange(field, data, timezone) {
      return /*#__PURE__*/_react["default"].createElement(_DateColumn.DateTimeRangeColumn, {
        startDate: data.startDate,
        endDate: data.endDate,
        allDay: data.allDay,
        timeZone: timezone
      });
    },
    DateRange: function dateTimeRange(field, data, timezone) {
      return /*#__PURE__*/_react["default"].createElement(_DateColumn.DateTimeRangeColumn, {
        startDate: data.startDate,
        endDate: data.endDate,
        allDay: data.allDay,
        timeZone: timezone
      });
    }
  },
  DateTime: {
    DateTime: function dateTime(field, data, timezone) {
      return /*#__PURE__*/_react["default"].createElement(_DateColumn.DateTimeColumn, {
        date: data,
        timeZone: timezone
      });
    }
  },
  Link: {
    Link: function link(field, data) {
      return /*#__PURE__*/_react["default"].createElement(_ComplexFieldColumns.LinkFieldColumn, {
        href: data.url,
        name: data.displayName
      });
    }
  },
  NumberRange: {
    Number: function numberRange(field, data) {
      return /*#__PURE__*/_react["default"].createElement(_Columns.NumberRangeColumn, data);
    },
    MaskedInput: function numberRangeMasked(field, data) {
      // TODO: Fix the FieldPropertiesDto interface or use the correct key here.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (field.properties.mask === "Currency") {
        return /*#__PURE__*/_react["default"].createElement(_Columns.CurrencyRangeColumn, data);
      }

      return null;
    }
  },
  Number: {
    MaskedInput: function numberMasked(field, data) {
      // TODO: Fix the FieldPropertiesDto interface or use the correct key here.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (field.properties.mask === "Currency") {
        return /*#__PURE__*/_react["default"].createElement(_Columns.CurrencyColumn, {
          value: data
        });
      }

      return null;
    }
  },
  Assets: function assets(field, data) {
    return /*#__PURE__*/_react["default"].createElement(_Columns.AssetsColumn, {
      value: data
    });
  },
  References: function references(field, data) {
    return /*#__PURE__*/_react["default"].createElement(_Columns.ReferencesColumn, {
      value: data
    });
  },
  Geolocation: function geolocation(field, data) {
    var props = _objectSpread(_objectSpread({}, data), {}, {
      field: _objectSpread({}, field)
    });

    return /*#__PURE__*/_react["default"].createElement(_Columns.GeolocationColumn, props);
  }
};

var ContentList = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ContentList, _React$Component);

  var _super = _createSuper(ContentList);

  function ContentList(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ContentList);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "contents", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "schemas", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "apps", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "categories", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "permissionSets", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadedCategories", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadedSets", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uiConfig", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      contentType: null,
      lastLoadedPartitions: {},
      context: {
        hcmsInstance: null,
        rowIndexMap: new Map(),
        selectedRows: new Set(),
        tableRef: null,
        filterList: [],
        clients: []
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reload", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var context;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              context = _this.state.context;

              if (!context.tableRef) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return context.tableRef.loadRows();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "buildColumns", function (contentType) {
      if (!contentType) {
        return [{
          name: "Loading Content..."
        }];
      }

      var fields = getFieldsToRender(contentType);
      return fields.map(function (field) {
        var defaultColumn = {
          name: field.name,
          label: (0, _Format.displayable)(field),
          options: {
            sort: false
          }
        };
        return _this.props.onBuildColumn && _this.props.onBuildColumn(field) || defaultColumn;
      }).concat(_this.defaultColumns(fields.length)).concat(hasActions(_this.props) ? [_AdvancedTableWrapper.AdvancedTableWrapper.defaultActionMenuColumn()] : []);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "defaultColumns", function (fieldsLength) {
      var context = _this.state.context;
      return [{
        name: "lastModified",
        label: "Updated",
        options: _objectSpread(_objectSpread({}, (0, _CommonTableComponents.makeDateRangeFilter)("Updated", null, true)), {}, {
          filterList: context.filterList[fieldsLength],
          sort: true,
          filter: true
        })
      }, {
        name: "status",
        label: "Status",
        options: _objectSpread(_objectSpread({}, (0, _CommonTableComponents.makeCustomSelectPicker)("Status", ["Published", "Draft", "Submitted", "Declined"].map(function (s) {
          return {
            label: s,
            value: s
          };
        }))), {}, {
          filterList: context.filterList[fieldsLength + 2],
          sort: true,
          filter: true
        })
      }, {
        name: "permissionSet/name",
        label: "Permission Set",
        options: _objectSpread(_objectSpread({}, (0, _CommonTableComponents.makeCustomSelectPicker)("Permission Set", _this.loadedSets.map(function (p) {
          return {
            label: p.name,
            value: p.name
          };
        }))), {}, {
          filterList: context.filterList[fieldsLength + 3],
          sort: true,
          filter: true,
          display: "false"
        })
      }, {
        name: "categories",
        label: "Categories",
        options: _objectSpread(_objectSpread({}, (0, _CommonTableComponents.makeCustomSelectPicker)("Categories", _this.loadedCategories.map(function (c) {
          return {
            label: c.name,
            value: c.name
          };
        }))), {}, {
          filterList: context.filterList[fieldsLength + 4],
          sort: false,
          filter: true,
          display: "false"
        })
      }];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onRowSelectionChange", function (selectedIndexes) {
      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          context: _objectSpread(_objectSpread({}, state.context), {}, {
            selectedRows: new Set(selectedIndexes)
          })
        });
      }, function () {
        if (_this.props.onSelect) {
          _this.props.onSelect(_this.getSelectedContentItems());
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "retrieveRows", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(state) {
        var _filter$search, _filter$getFilterQuer, _contentItems$total;

        var contentType, page, sortColumn, sortDirection, search, rowsPerPage, filterList, pagination, sortColumnInfo, partition, lastLoadedPartitions, possiblePartitions, sortProperty, getSortRequest, getFilterRequest, sort, filter, contentItems, rowIndexMap, data;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contentType = _this.state.contentType;

                if (contentType) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", {
                  count: 0,
                  data: [],
                  status: _AdvancedTableWrapperConstants.RowStatus.Loading
                });

              case 3:
                if (!(_this.props.filterByIds && _this.props.filterByIds.length === 0)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", {
                  count: 0,
                  data: [],
                  status: _AdvancedTableWrapperConstants.RowStatus.Complete
                });

              case 5:
                page = state.page, sortColumn = state.sortColumn, sortDirection = state.sortDirection, search = state.search, rowsPerPage = state.rowsPerPage, filterList = state.filterList;
                pagination = new PaginationRequest(rowsPerPage, rowsPerPage * page);
                sortColumnInfo = contentType.fields.find(function (w) {
                  return w.name === state.sortColumn;
                });
                partition = sortColumnInfo ? PartitionMap[sortColumnInfo.partitioning.toLowerCase()] || sortColumnInfo.partitioning : "iv";
                /**
                 * If the content item does not contain the partition calculated above, we need to just
                 * grab the first off of the last loaded partitions for the content item.
                 *
                 * This is needed because the content type returns "language" as the partition if there are multiple languages
                 * This is what would be calculated by the code above because it checks the content type partition, instead of
                 * what is actually on the content items.
                 *
                 * So what ends up happening is it tries to sort on /data/language/ instead of an actual language like "en" or "iv".
                 * To fix this, we just check what is possible on the content item itself.
                 */

                lastLoadedPartitions = _this.state.lastLoadedPartitions;

                if (Object.keys(lastLoadedPartitions).length > 0 && sortColumnInfo) {
                  possiblePartitions = lastLoadedPartitions[sortColumnInfo.name];

                  if (possiblePartitions && !possiblePartitions.includes(partition)) {
                    partition = possiblePartitions[0];
                  }
                }
                /**
                 * Override the sort value for specific field types.
                 * This is needed if the content type is a complex object such as NumberRange, which requires
                 * you to specify a specific field to filter on, since it has more than one field.
                 */


                sortProperty = sortColumnInfo ? SortMap[sortColumnInfo.properties.fieldType] || "" : "";
                /**
                 * Allow the sort property calculated from the SortMap to be overriden by a passed in prop.
                 */

                if (sortColumnInfo) {
                  sortProperty = _this.props.getSortProperty ? _this.props.getSortProperty(contentType, sortColumnInfo) || sortProperty : sortProperty;
                }

                getSortRequest = function getSortRequest(column) {
                  switch (column) {
                    case "lastModified":
                    case "status":
                      return new SortRequest(column, sortDirection, partition, true, null);

                    default:
                      return new SortRequest(sortColumn, sortDirection, partition, false, sortProperty);
                  }
                };

                getFilterRequest = function getFilterRequest(filterList, search) {
                  var fieldsLength = getFieldsToRender(contentType).length;

                  var filter = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _odataHelper.buildDateFilter)(filterList[fieldsLength], "lastModified")), (0, _odataHelper.buildUserFilter)(filterList[fieldsLength + 1], "lastModifiedBy")), (0, _odataHelper.buildCustomSelectPickerFilter)(filterList[fieldsLength + 2], "status")), (0, _odataHelper.buildCustomSelectPickerFilter)(filterList[fieldsLength + 3], "permissionSet/name")), (0, _odataHelper.buildCustomSelectPickerFilter)(filterList[fieldsLength + 4], "categories", true, "name"));

                  if (_this.props.filterByIds) {
                    filter = _objectSpread(_objectSpread({}, (0, _odataHelper.buildIdFilter)(_this.props.filterByIds, "id", true)), filter);
                  }

                  return new FilterRequest([], null, search || null, null, filter);
                };

                sort = getSortRequest(sortColumn);
                filter = getFilterRequest(filterList, search);
                _context2.next = 19;
                return _this.contents.getContents(_this.props.config.appName, _this.props.schema, (_filter$search = filter.search) !== null && _filter$search !== void 0 ? _filter$search : undefined, pagination.top, pagination.skip, sort.column ? "".concat(sort.column, " ").concat(sort.direction) : undefined, (_filter$getFilterQuer = filter.getFilterQuery()) !== null && _filter$getFilterQuer !== void 0 ? _filter$getFilterQuer : undefined);

              case 19:
                contentItems = _context2.sent;

                _this.onContentDataLoaded(contentItems.items);

                rowIndexMap = new Map(_this.state.context.rowIndexMap);
                data = contentItems.items.map(function (i, index) {
                  i = fixMissingProperties(i, contentType);
                  rowIndexMap.set(index, i);

                  var actionMenuProps = _objectSpread(_objectSpread({}, _this.props), {}, {
                    index: index,
                    row: i
                  });

                  var lastModifiedProps = {
                    item: i,
                    timezone: "America/Chicago"
                  };
                  var keys = Object.keys(i.data);
                  return keys.filter(function (key) {
                    return shouldRenderContent(contentType, key);
                  }).map(function (key) {
                    var contentItemData = i.data[key];
                    var field = contentType.fields.find(function (w) {
                      return w.name === key;
                    }); // Allow the caller to override how the row is built. If they do not pass anything in or return undefined, just fall back to our default renderer.

                    if (field) {
                      return _this.props.onBuildRow && _this.props.onBuildRow(contentType, field, contentItemData) || getFieldRenderer(field, contentItemData, _this.props);
                    } else {
                      throw new Error("Unable to find field");
                    }
                  }).concat([/*#__PURE__*/_react["default"].createElement(LastModifiedCell, (0, _extends2["default"])({
                    key: "last-modified-".concat(index)
                  }, lastModifiedProps))]).concat([/*#__PURE__*/_react["default"].createElement(ContentStatusCell, (0, _extends2["default"])({
                    key: "content-status-".concat(index)
                  }, lastModifiedProps))]).concat([/*#__PURE__*/_react["default"].createElement(PermissionSetCell, (0, _extends2["default"])({
                    key: "permission-set-".concat(index)
                  }, i))]).concat([/*#__PURE__*/_react["default"].createElement(CategoriesCell, (0, _extends2["default"])({
                    key: "categories-".concat(index)
                  }, i))]).concat([/*#__PURE__*/_react["default"].createElement(ActionMenu, (0, _extends2["default"])({
                    key: "action-menu-".concat(index)
                  }, actionMenuProps))]);
                });

                _this.setState(function (state) {
                  return _objectSpread(_objectSpread({}, state), {}, {
                    context: _objectSpread(_objectSpread({}, state.context), {}, {
                      rowIndexMap: rowIndexMap
                    })
                  });
                });

                return _context2.abrupt("return", {
                  count: (_contentItems$total = contentItems.total) !== null && _contentItems$total !== void 0 ? _contentItems$total : 0,
                  data: data
                });

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedContentItems", function () {
      var rows = [];
      var context = _this.state.context;
      context.selectedRows.forEach(function (a) {
        if (!context.rowIndexMap.has(a)) {
          return;
        }

        var thisRow = context.rowIndexMap.get(a);
        if (thisRow) rows.push(thisRow);
      });
      return rows;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "buildBulkActions", function () {
      if (!hasActions(_this.props) || !_this.props.actions) {
        return null;
      }

      return _this.props.actions.map(function (a) {
        return {
          display: a.display,
          action: function action() {
            return a.action(_this.getSelectedContentItems());
          }
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onContentDataLoaded", function (data) {
      var results = {};
      data.forEach(function (w) {
        Object.keys(w.data).forEach(function (k) {
          // The possible languages for the particular field.
          results[k] = Object.keys(w.data[k]);
        });
      });

      _this.setState({
        lastLoadedPartitions: results
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onRowsSelect", function (selected, allSelected) {
      _this.onRowSelectionChange(allSelected.map(function (w) {
        return w.index;
      }));
    });
    var config = props.includeUnpublished ? (0, _Config.includeFlow)(props.config) : props.config;
    _this.contents = new _sdk.ContentsApi(config);
    _this.schemas = new _sdk.ContentTypesApi(config);
    _this.apps = new _sdk.AppClientsApi(config);
    _this.categories = new _sdk.CategoriesApi(config);
    _this.permissionSets = new _sdk.PermissionSetApi(config);
    return _this;
  }

  (0, _createClass2["default"])(ContentList, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var _this2 = this;

        var contentType, categories, sets;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.schemas.getContentType(this.props.config.appName, this.props.schema);

              case 2:
                contentType = _context4.sent;
                _context4.next = 5;
                return this.categories.getCategories(this.props.config.appName);

              case 5:
                categories = _context4.sent;
                _context4.next = 8;
                return this.permissionSets.getPermissionSets(this.props.config.appName);

              case 8:
                sets = _context4.sent;
                this.loadedCategories = categories.items;
                this.loadedSets = sets.items;

                if (!(Object.keys(contentType).length < 1)) {
                  _context4.next = 13;
                  break;
                }

                throw new Error("Failed to retrieve content type by schema of: " + this.props.schema);

              case 13:
                this.setState({
                  contentType: contentType
                }, /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                  var clients;
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this2.props.onRef && _this2.props.onRef({
                            refreshListing: function refreshListing() {
                              return _this2.reload();
                            },
                            getContentType: function getContentType() {
                              return contentType;
                            },
                            unselectAllRows: function unselectAllRows() {
                              _this2.setState(function (state) {
                                return _objectSpread(_objectSpread({}, state), {}, {
                                  context: _objectSpread(_objectSpread({}, state.context), {}, {
                                    selectedRows: new Set()
                                  })
                                });
                              });
                            }
                          });
                          _context3.next = 3;
                          return _this2.apps.getClients(_this2.props.config.appName);

                        case 3:
                          clients = _context3.sent.items;

                          _this2.setState(function (state) {
                            return _objectSpread(_objectSpread({}, state), {}, {
                              context: _objectSpread(_objectSpread({}, state.context), {}, {
                                clients: clients
                              })
                            });
                          });

                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          header = _this$props.header,
          subheader = _this$props.subheader,
          id = _this$props.id;
      var rowsPerPage = this.props.pagination ? this.props.pagination.rowsPerPage : 25;
      var _this$state = this.state,
          contentType = _this$state.contentType,
          context = _this$state.context;
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        id: id,
        className: (0, _classnames["default"])("prmbl-contentList", className),
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: "prmbl-contentList-header",
        variant: "h6",
        gutterBottom: true
      }, header), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: "prmbl-contentList-subheader",
        variant: "subtitle1",
        gutterBottom: true,
        color: "textSecondary"
      }, subheader)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        className: "prmbl-contentList-headerButtons",
        item: true,
        xs: 6
      }, /*#__PURE__*/_react["default"].createElement(HeaderButtons, this.props)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        className: "prmbl-contentList-tableContainer",
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_AdvancedTableWrapper["default"], {
        key: JSON.stringify(contentType),
        showSearch: true,
        showFilter: false,
        enablePreload: this.props.enablePreload,
        preloadedDataExpirationSeconds: this.props.preloadExpirationSeconds,
        onRowsSelect: this.onRowsSelect,
        bulkActions: this.buildBulkActions(),
        selectableRows: this.props.selectableRows,
        onRowClick: function onRowClick(data, index) {
          var rowIndex = index.rowIndex;
          var map = context.rowIndexMap;

          if (_this3.props.onRowClick && map.has(rowIndex)) {
            var value = map.get(rowIndex);
            if (value) _this3.props.onRowClick(value);
          }
        },
        columns: this.buildColumns(contentType),
        emptyMessage: this.props.emptyState || DEFAULT_EMPTY_MESSAGE,
        serverSide: true,
        rows: this.retrieveRows,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: this.props.pagination ? this.props.pagination.rowsPerPageOptions : [],
        rowsSelected: Array.from(context.selectedRows),
        compact: this.props.compact,
        onRef: function onRef(ref) {
          _this3.setState(function (state) {
            return _objectSpread(_objectSpread({}, state), {}, {
              context: _objectSpread(_objectSpread({}, state.context), {}, {
                tableRef: ref
              })
            });
          });
        }
      })));
    }
  }]);
  return ContentList;
}(_react["default"].Component);

exports.ContentList = ContentList;
var _default = ContentList;
exports["default"] = _default;